export default 'Diagnostic 60 sec — Estimer mes primes CEE | Solution Éco France';
